module.exports = __webpack_public_path__ + "static/media/轉所申請書中英文版及推薦書-定稿.9757b2f4.pdf";